// extracted by mini-css-extract-plugin
export default {"container":"Header_container__m3lai","heading":"Header_heading__uYpTc","right":"Header_right__y9dYc"};